import { Link } from 'react-router-dom';

const CATEGORY_LINKS = [
  { to: '/category/movie', label: '电影频道' },
  { to: '/category/tv', label: '电视剧频道' },
  { to: '/category/variety', label: '综艺频道' },
  { to: '/search', label: '全站搜索' },
];

const ABOUT_LINKS = [
  { to: '/about', label: '关于我们' },
  { to: '/about', label: '服务范围' },
  { to: '/about', label: '意见反馈' },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-primary-900/40 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-play-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-extrabold tracking-tight text-background-50">
                91视频在线
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              91视频在线是一个专注影视内容聚合与浏览的高清在线视频平台，提供电影、电视剧、综艺等丰富资源的分类检索与信息展示，帮助用户快速发现并了解感兴趣的影视作品。
            </p>
            <p className="mt-3 text-xs leading-relaxed text-background-400">
              温馨提示：本站视频播放区域仅为界面演示，暂未接入真实视频播放或在线流媒体服务；站内内容为原创示范数据，仅用于产品展示。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/" className="inline-flex items-center gap-1 hover:text-accent-300">
                内容导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {CATEGORY_LINKS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              <Link to="/about" className="inline-flex items-center gap-1 hover:text-accent-300">
                帮助与支持
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {ABOUT_LINKS.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 space-y-2 text-sm text-background-300">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-300" />
                support@91video.example
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-service-line text-accent-300" />
                工作日 9:00 - 18:00
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900/60 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 91视频在线 · 高清在线视频播放平台 · 保留所有权利</p>
          <p>本站为产品演示站点，内容均为原创示范数据</p>
        </div>
      </div>
    </footer>
  );
}